import type { ReactNode } from 'react'

export function StatusScreen(props: { title: string; detail?: string; children?: ReactNode }) {
  return (
    <div className="status-screen">
      <div className="status-card">
        <h1>{props.title}</h1>
        {props.detail ? <p>{props.detail}</p> : null}
        {props.children}
      </div>
    </div>
  )
}
